import { CanDeactivate } from "@angular/router";
import { ConfirmLeaveBacklogUnsyncedComponent } from "../confirm-leave-backlog-unsynced/confirm-leave-backlog-unsynced.component";
import { Observable } from "rxjs/Observable";
import { SprintsComponent } from "./sprints.component";

export class SprintsConfirmDeactivateGuard
  implements CanDeactivate<SprintsComponent> {
  canDeactivate(target: SprintsComponent): Observable<boolean> {
    if (!localStorage.getItem("stayUnsyncedNotification")) {
      return target.project && target.project.unsyncedChanges
        ? (<ConfirmLeaveBacklogUnsyncedComponent>(
            target.modalService.open(ConfirmLeaveBacklogUnsyncedComponent)
              .instance
          )).result.asObservable()
        : Observable.of(true);
    } else {
      return Observable.of(true);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/sprints/confirm-deactivate.guard.ts